import React from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import compose from 'recompose/compose';
import utils from 'helpers/utils';
import { connect } from 'react-redux';

class ReferenceShowField extends React.Component {
    componentDidMount() {
        const { data } = this.props;

        if (utils.isEmpty(data)) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.fetchData();
        }
    }

    fetchData() {
        const { action, dispatchAction, value } = this.props;

        /**
         * This will trigger a specific action, which is defined in the upper level.
         * This action can only be a function, and will always pass the id of the record.
         */

        dispatchAction(action({
            id: value,
        }));
    }

    render() {
        const { data, display, label } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        const result = utils.get(data, display) || null;

        return <TextField label={ label } value={ result } />;
    }
}

ReferenceShowField.propTypes = {
    action: PropTypes.func.isRequired,
    data: PropTypes.object,
    dispatchAction: PropTypes.func.isRequired,
    display: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

const mapStateToProps = (state, props) => {
    const { resource, value } = props;

    const stateResource = state[resource];

    return {
        data: stateResource.data[value],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (action) => {
            dispatch(action);
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(ReferenceShowField);



// WEBPACK FOOTER //
// ./src/components/show/ReferenceShowField.js